const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': 'Свидетельство о регистрации транспортного средства',
	'vehicleRegistrationDocument.description':
		'Загрузите четкие фотографии запрошенных сторон свидетельства о регистрации.',
	'vehicleRegistrationDocument.RegistrationDocument.title':
		'Лицевая сторона свидетельства о регистрации',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Сделайте четкую фотографию лицевой стороны свидетельства о регистрации.',
	'vehicleRegistrationDocument.RegistrationDocument.headline':
		'Лицевая сторона свидетельства о регистрации',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle':
		'Лицевая сторона свидетельства о регистрации - пример',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired':
		'Лицевая сторона свидетельства о регистрации',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title':
		'Обратная сторона свидетельства о регистрации',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Сделайте четкую фотографию обратной стороны свидетельства о регистрации.',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline':
		'Обратная сторона свидетельства о регистрации',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'Обратная сторона свидетельства о регистрации - пример',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired':
		'Обратная сторона свидетельства о регистрации',
	'vehicleRegistrationDocument.validationHeadline': 'Не хватает фотографий',
	'vehicleRegistrationDocument.validationDescription': 'Добавьте следующие фотографии:',
	'landing.stepDescription.vehicleRegistrationDocument':
		'Сфотографируйте свидетельство о регистрации',
	'review.stepDescription.vehicleRegistrationDocument':
		'Свидетельство о регистрации транспортного средства',
	'editPhoto.edit': 'Изменять',

	'blockedByDevice.headline': 'PolicyCheck не поддерживает настольные браузеры.',
	'blockedByDevice.description':
		'PolicyCheck использует настольный браузер.\r\nПлатформа PolicyCheck выполняет документирование дел с помощью мобильных устройств.\r\nЧтобы продолжить, перейдите по ссылке PolicyCheck на мобильном устройстве.',

	'button.changeImage': 'Поменять фото',
	'button.deleteImage': 'Удалить фото',
	'button.next': 'Следующий',
	'button.start': 'Начните',
	'button.prev': 'Назад',
	'button.continue': 'Продолжайте',
	'button.ok': 'Ok',
	'button.close': 'Закрой его',
	'button.addLater': 'добавить позже',
	'button.backchangeImage': 'Назад и изменить изображение',
	'loader.error': 'Ваш процесс не может быть загружен. Пожалуйста, попробуйте позже...',
	'loader.loading': 'Загрузка данных ...',
	'mainError.tryAgain': 'Попробуйте снова',

	'landing.stepDescription.fourDiagonalPerspectives': 'Сделайте необходимые снимки',
	'landing.stepDescription.fourAdditionalPictures': 'Загрузите фотографии',
	'landing.stepDescription.feedback': 'Оставьте нам свой отзыв',
	'landing.headline.policyCheck': 'Добро пожаловать',
	'landing.paragraph': 'Весь процесс займет всего три шага',
	'landing.termsAndConditionsLink': 'Продолжая, вы соглашаетесь с нашими условиями',
	'landing.termsAndConditionsLinkDescription': ' ',
	'landing.aboutPolicyCheck': ' ',

	'vehicleImages.overviewPhotos': 'Осмотр автомобиля',
	'vehicleImages.overviewPhotos.subtitle': 'Сфотографировать автомобиль',
	'vehicleImages.description':
		'Сфотографируйте автомобиль по диагонали спереди слева и справа, сзади слева и справа. Номерной знак должен быть виден на всех снимках',
	'vehicleImages.leftFrontOverview': 'Фото по диагонали спереди - левая сторона',
	'vehicleImages.leftRearOverview': 'Фото по диагонали сзади - левая сторона',
	'vehicleImages.rightRearOverview': 'Фото сзади по диагонали - правая сторона',
	'vehicleImages.rightFrontOverview': 'Фото по диагонали спереди - правая сторона',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft':
		'Фото по диагонали спереди - левая сторона',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Фото сзади по диагонали - правая сторона',
	'completeVehicleImagesModal.hasVehicleImageFrontRight':
		'Фото по диагонали спереди - правая сторона',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Фото по диагонали сзади - левая сторона',
	'completeVehicleImagesModal.headline': 'намекать',
	'completeVehicleImagesModal.description': 'Пожалуйста, добавьте следующую информаци',
	'completeFourAdditionalPicturesModal.headline': 'намекать',
	'completeFourAdditionalPicturesModal.description': 'Пожалуйста, добавьте следующую информаци',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage':
		'Общее изображение приборной панели',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Фото пробега',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Изображение лобового стекла',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Фотография номера VIN',
	'landing.changeLang': 'Чтобы изменить язык, щелкните здесь.',
	'chooseLang.headline': 'Выберите предпочтительный язык',
	'fourPerspectivesExampleModal.button.close': 'Закрыть',
	'fourPerspectivesExampleModal.headline.first': 'Дополнительные изображения',

	'fourAdditionalPictures.title': 'Дополнительные изображения',
	'fourAdditionalPictures.overallDashboard.title': 'Приборная панель автомобиля',
	'fourAdditionalPictures.overallDashboard.description':
		'Сфотографируйте приборную панель вашего автомобиля полностью.',
	'fourAdditionalPictures.mileage.title': 'Пробег',
	'fourAdditionalPictures.mileage.description':
		'Пожалуйста, сфотографируйте свой пробег. Если в вашем автомобиле есть цифровой дисплей, включите его.',
	'fourAdditionalPictures.mileage.enter': 'Введите пробег автомобиля',
	'fourAdditionalPictures.windshield.title': 'Переднее лобовое стекло автомобиля',
	'fourAdditionalPictures.windshield.description':
		'Пожалуйста, сделайте подробную фотографию переднего лобового стекла вашего автомобиля.',
	'fourAdditionalPictures.vin.title': 'VIN-номер автомобиля',
	'fourAdditionalPictures.vin.description':
		'Пожалуйста, сфотографируйте VIN-номер вашего автомобиля. Вы можете найти это на уплотнении двери водителя или в нижнем левом углу лобового стекла.',
	'fourAdditionalPicturesExampleModal.headline.first': 'Дополнительные изображения',
	'fourAdditionalPicturesExampleModal.button.close': 'Закрыть',
	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'Образцовая фотография',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Образцовая фотография',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'Образцовая фотография',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Образцовая фотография',

	'fourDiagonalPerspectives.vehicleFrontRight.title': ' ',
	'fourDiagonalPerspectives.vehicleRearRight.title': ' ',
	'fourDiagonalPerspectives.vehicleRearLeft.title': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': ' ',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle': 'Образцовая фотография',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle': 'Образцовая фотография',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle': 'Образцовая фотография',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle': 'Образцовая фотография',

	'overallDashboardImage.headline': 'Общее изображение приборной панели',
	'dashboardMileage.dashboard.title': 'Фото пробега',
	'dashboardMileage.placeholder': 'например 150000 км',
	'dashboardMileage.dashboard.paragraph':
		'Сфотографируйте приборную панель автомобиля с полностью видимым пробегом. Если в вашем автомобиле есть электронные дисплеи, включите их.',
	'dashboardMileage.paragraph.first': 'Введите пробег автомобиля.',
	'windshieldImage.headline': 'Изображение лобового стекла',
	'vinPicture.headline': 'Фотография с видимым номером VIN',
	'imageRecognitionMismatchModal.headline': 'Вы уверены, что добавили нужное фото?',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Образцовая фотография',

	'review.button.next': 'Следующий',

	'upload.message':
		'Ваши данные будут загружены. В зависимости от вашего интернет-соединения этот процесс может занять несколько минут.',
	'feedback.headline': 'Фотографии успешно получены!',
	'feedback.headline.policyCheck': 'Фотографии успешно получены!',
	'feedback.button.send': 'Отправить',
	'feedback.description': ' ',
	'feedback.yourOpinion': 'комментарий',
	'feedback.rating.policyCheck':
		'Во сколько звезд вы бы оценили приложение с учетом вашего первого опыта работы в приложении, по 5 бальной ситеме оценки?',
	'thanksForFeedback.headline.first': 'Мы ценим Ваш отзыв!',
	'waitForAudit.thankYou': 'Мы ценим Ваш отзыв!',
	'waitForAudit.description.damageFound': 'Спасибо за доверие к Allianz',
	'waitForAudit.description.damageNotFound': 'Спасибо за доверие к Allianz',
	'waitforAudit.finish': 'Готово',

	'thanks.headline.first': 'Спасибо!',
	'thanks.paragraph.first': 'спасибо за использование EasyClaim!',
	'timeout.bottom': ' ',
	'testcasemodal.headline': 'Test case warning!',
	'testcasemodal.accept': 'Accept',
	'testcasemodal.paragraph': 'Be aware it is a test case!',
	'testcasewarningalert.paragraph': 'This is test case!',
};

export default messages;
